import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const BrowsePage = lazy(() => import("../pages/browse/page"));
const BrowseVehiclesPage = lazy(() => import("../pages/browse-vehicles/page"));
const ItemDetailPage = lazy(() => import("../pages/item-detail/page"));
const VehicleDetailPage = lazy(() => import("../pages/vehicle-detail/page"));
const PostItemPage = lazy(() => import("../pages/post-item/page"));
const ProfilePage = lazy(() => import("../pages/profile/page"));
const MessagesPage = lazy(() => import("../pages/messages/page"));
const CompareVehiclesPage = lazy(() => import("../pages/compare-vehicles/page"));
const ProposalsPage = lazy(() => import("../pages/proposals/page"));
const AdminDashboard = lazy(() => import("../pages/admin/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/browse",
    element: <BrowsePage />,
  },
  {
    path: "/browse-vehicles",
    element: <BrowseVehiclesPage />,
  },
  {
    path: "/item/:id",
    element: <ItemDetailPage />,
  },
  {
    path: "/vehicle/:id",
    element: <VehicleDetailPage />,
  },
  {
    path: "/post-item",
    element: <PostItemPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/messages",
    element: <MessagesPage />,
  },
  {
    path: "/compare-vehicles",
    element: <CompareVehiclesPage />,
  },
  {
    path: "/proposals",
    element: <ProposalsPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
